var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "add_purchase_order",
      attrs: {
        visible: _vm.dialogVisible,
        "append-to-body": true,
        title: _vm.dialogTitle,
        width: "1280px",
        "modal-append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "purchase-order" },
        [
          _vm.isEdit
            ? _c(
                "div",
                { staticClass: "base-info-readonly" },
                [
                  _c("div", { staticClass: "order-form" }, [
                    _vm._v(" 基础信息 "),
                  ]),
                  _c(
                    "el-row",
                    { staticClass: "info-row", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("退货单号：")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.baseInfo.returnOrderNo || "无")),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("退货单创建人：")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.baseInfo.createdByName || "无")),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("关联采购单号：")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.baseInfo.purchaseOrderNo || "无")
                            ),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("退货单状态：")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.baseInfo.statusLabel || "无")),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "info-row", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("采购退货单创建时间：")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.baseInfo.createdTime || "无")),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("修改时间：")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.baseInfo.updatedTime || "无")),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("退货数：")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.baseInfo.totalReturnQuantity || "无")
                            ),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("退货金额：")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.baseInfo.totalReturnAmount || "无")
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "orderForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "110px",
                "label-position": "right",
              },
            },
            [
              _c("div", { staticClass: "order-form" }, [
                _vm._v(" 退货商品信息 "),
              ]),
              _c(
                "div",
                { staticClass: "goods-table-container" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "goods-table",
                          staticStyle: { width: "100%", "margin-top": "10px" },
                          attrs: {
                            data: _vm.form.items,
                            border: "",
                            "summary-method": _vm.getSummaries,
                            "show-summary": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "序号",
                              width: "60",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "商品名称",
                              "min-width": "150",
                              "class-name": "goods-name-cell",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "goods-name-text" },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.goodsName || "-")
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "规格", "min-width": "100" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "goods-name-text" },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.specification || "-")
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "单位",
                              prop: "unitOfMeasure",
                              width: "120",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "canReturnQuantity",
                              label: "可退货数量",
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.canReturnQuantity || 0)
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "returnQuantity",
                              label: "采购退货数量",
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    !_vm.isEditable
                                      ? _c("el-input", {
                                          attrs: { placeholder: "请输入" },
                                          on: {
                                            change: _vm.calculateTotalAmount,
                                          },
                                          model: {
                                            value: scope.row.returnQuantity,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "returnQuantity",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.returnQuantity",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.returnQuantity || 0
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "lineReturnAmount",
                              label: "退货金额(元)",
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    !_vm.isEditable
                                      ? _c("el-input", {
                                          attrs: { placeholder: "请输入" },
                                          on: {
                                            change: _vm.calculateTotalAmount,
                                          },
                                          model: {
                                            value: scope.row.lineReturnAmount,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "lineReturnAmount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.lineReturnAmount",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatCurrency(
                                                scope.row.lineReturnAmount
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "供应商", "min-width": "150" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "goods-name-text" },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.supplierName || "-")
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "备注", "min-width": "150" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    !_vm.isEditable
                                      ? _c("el-input", {
                                          attrs: { placeholder: "请输入" },
                                          model: {
                                            value: scope.row.returnReason,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "returnReason",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.returnReason",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.returnReason || "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "order-form" }, [_vm._v(" 采购信息 ")]),
              _c(
                "el-row",
                {
                  staticClass: "info-row",
                  staticStyle: {
                    "padding-left": "45px",
                    "margin-bottom": "10px",
                  },
                  attrs: { gutter: 20 },
                },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("采购员：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.form.purchaserName || "无")),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("运费：")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.formatCurrency(_vm.form.freightCost) || "无"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("优惠金额：")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.formatCurrency(_vm.form.discountAmount) || "无"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("采购总金额：")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.formatCurrency(_vm.form.finalAmount) || "无"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticClass: "info-row",
                  staticStyle: {
                    "padding-left": "45px",
                    "margin-bottom": "10px",
                  },
                  attrs: { gutter: 20 },
                },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("收货地址：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.form.shippingAddress || "无")),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("采购单备注：")]),
                      _c("span", [_vm._v(_vm._s(_vm.form.remarks || "无"))]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("附件：")]),
                      _vm.form.purchaseAttachmentUrl
                        ? _c("div", { staticClass: "attachment-display" }, [
                            _c(
                              "a",
                              {
                                staticClass: "attachment-link",
                                attrs: {
                                  href: _vm.form.purchaseAttachmentUrl,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-document" }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.form.purchaseAttachmentName ||
                                        "下载附件"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : _c("span", { staticClass: "info-text" }, [
                            _vm._v(
                              _vm._s(_vm.form.purchaseAttachmentName || "无")
                            ),
                          ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "order-form" }, [_vm._v(" 退货信息 ")]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "退货员", prop: "returnerName" } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "returnSelect",
                              attrs: {
                                disabled: _vm.isEditable,
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              on: {
                                focus: _vm.openUserPicker,
                                "visible-change": _vm.handleReturnSelectVisible,
                              },
                              model: {
                                value: _vm.form.returnerName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "returnerName", $$v)
                                },
                                expression: "form.returnerName",
                              },
                            },
                            [
                              _vm.form.returnerId && _vm.form.returnerName
                                ? _c("el-option", {
                                    key: _vm.form.returnerId,
                                    attrs: {
                                      label: _vm.form.returnerName,
                                      value: _vm.form.returnerName,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "运费", prop: "returnFreightCost" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.isEditable,
                              placeholder: "请输入",
                            },
                            on: { change: _vm.calculateTotalAmount },
                            model: {
                              value: _vm.form.returnFreightCost,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "returnFreightCost", $$v)
                              },
                              expression: "form.returnFreightCost",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "退货总金额",
                            prop: "finalReturnAmount",
                          },
                        },
                        [
                          _c("span", { staticClass: "total-amount-text" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatCurrency(_vm.calculatedTotalAmount)
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "退货地址", prop: "returnAddress" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.isEditable,
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.returnAddress,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "returnAddress", $$v)
                              },
                              expression: "form.returnAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "退货单备注", prop: "returnRemarks" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.isEditable,
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.returnRemarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "returnRemarks", $$v)
                              },
                              expression: "form.returnRemarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "附件", prop: "attachmentUrl" } },
                        [
                          !_vm.isEditable
                            ? _c(
                                "div",
                                [
                                  _vm.fileList.length === 0
                                    ? _c(
                                        "el-upload",
                                        {
                                          ref: "upload",
                                          attrs: {
                                            accept: "*",
                                            drag: "",
                                            action: "#",
                                            multiple: false,
                                            "http-request": _vm.orderImportLive,
                                            limit: 1,
                                            "before-upload": _vm.beforeUpload,
                                            "file-list": _vm.fileList,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                plain: "",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("点击上传")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c("div", { staticClass: "file-list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "file-item" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-document",
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "file-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.fileList[0].name)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "mini",
                                                },
                                                on: { click: _vm.handleRemove },
                                              },
                                              [_vm._v("删除")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                  _c("div", { staticClass: "upload-tips" }, [
                                    _vm._v(
                                      " (大小限制在10M以内，支持 .doc, .docx, .xls, .xlsx, .pdf, .jpg, .jpeg, .png 格式文件) "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _c("div", [
                                _vm.form.attachmentUrl
                                  ? _c(
                                      "div",
                                      { staticClass: "attachment-display" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "attachment-link",
                                            attrs: {
                                              href: _vm.form.attachmentUrl,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-document",
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.form.attachmentName ||
                                                    "下载附件"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c("span", { staticClass: "info-text" }, [
                                      _vm._v("无附件"),
                                    ]),
                              ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.type === "add" || (_vm.isEdit && _vm.baseInfo.status === 0)
            ? _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    loading: _vm.submitLoading,
                    disabled: _vm.submitLoading,
                  },
                  on: { click: _vm.submitForm },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.submitLoading ? "生效中..." : "确认生效") +
                      " "
                  ),
                ]
              )
            : _vm._e(),
          _vm.type === "add" || (_vm.isEdit && _vm.baseInfo.status === 0)
            ? _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    loading: _vm.saveLoading,
                    disabled: _vm.saveLoading,
                  },
                  on: { click: _vm.saveForm },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.saveLoading ? "保存中..." : "保存") + " "
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "选择退货员", multiple: false },
        on: { ok: _vm.selectedReturner },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }